import apiConfig from "../../apiConfig";

export const validateTypeData = async (
	at,
	{ Donation_Type_Name_EN = "", Donation_Type_Name_AR = "", Donation_Type_Id }
) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Types/Validate_Donation_Type",
		{
			Donation_Type_Name_EN,
			Donation_Type_Name_AR,
			Donation_Type_Id,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
